// extracted by mini-css-extract-plugin
export default {"container":"ES-z","title":"FS-z","link":"GS-z"};